import { convertToMomentDate, dateFormat, getClientBreadCrumbs, userFullName } from "helpers/common";
import { useMemo, useState } from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { Breadcrumbs, CstmPagination, NoRecordFoundV2 } from "components/Common/Common";
import userImg from 'Assets/images/user.png';
import downArrow from "Assets/images/downArro.png";
import rightArrow from "Assets/images/rightArro.png";
import { useGetClientCaseloadsListQuery, useGetCliniciansHistoryQuery } from "store/services/clientCaseLoads";

const CliniciansHistory = ({ }) => {
    const navigate = useNavigate()
    const { clientId, clientType } = useParams()
    const pageSize = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState({})

    const { data: caseLoadsList, isFetching, isLoading } = useGetCliniciansHistoryQuery({ clientId })
    const totalRecords = caseLoadsList?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize)

    const breadcrumbItems = useMemo(() => getClientBreadCrumbs(clientId, clientType, caseLoadsList?.record, "Clinician's History"), [clientType, caseLoadsList?.record, clientId]);

    const [openDiscipline, setOpenDiscipline] = useState(null);

    const toggleDiscipline = (id) => {
        setOpenDiscipline(prev => prev === id ? null : id);
    };

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    return (
        <>

            {
                (isLoading) ? <LoadingIndicator /> : <div className="">
                    {(isFetching) && <LoadingOverlay />}
                    <section
                        className={`position-relative ClientDetail`}
                    >
                        <Container fluid>
                            <div style={{ paddingLeft: "12px" }}>
                                <Row className="pt-3">
                                    <Col lg="6">
                                        <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ padding: "12px", borderRadius: "4px" }}>

                                <Row className="justify-content-between" >
                                    <Col lg='9'>
                                        <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                            Clinicians History
                                        </p>
                                    </Col>
                                    <Col lg='2' style={{ textAlign: "center" }}>

                                    </Col>
                                </Row>
                                {
                                    caseLoadsList?.record?.clientCaseloadsDischarged?.length > 0 ?
                                        <>
                                            {
                                                caseLoadsList?.record?.clientCaseloadsDischarged?.map((item, index) =>
                                                    item?.case_status == "pending" &&

                                                    <div className="mt-2">

                                                        <table className="w-100">
                                                            <thead>
                                                                <tr>
                                                                    <th className="fw-medium w-50" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                                        DISCIPLINE
                                                                    </th>
                                                                    {/* <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        TOTAL ATTENDED
                                                    </th>
                                                    <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        TOTAL SCHEDULED
                                                    </th> */}
                                                                    <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }} ></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    item?.clientCaseloadTherapist?.map((assignment) => {
                                                                        return (
                                                                            <>
                                                                                <tr onClick={() => toggleDiscipline(assignment?.id)} style={{ backgroundColor: "#F8F8F8" }}>
                                                                                    <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F", borderRadius: 0 }}>
                                                                                        <span className={`discipline-${item?.caseDiscipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "0px" }}>{assignment?.caseDiscipline?.assign_term}</span>
                                                                                    </td>
                                                                                    <td className="text-end" style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: "0" }}>
                                                                                        <img
                                                                                            src={openDiscipline === assignment?.id ? downArrow : rightArrow}
                                                                                            width={openDiscipline === assignment?.id ? 12 : 7}
                                                                                            alt="toggle"
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                                {openDiscipline === assignment?.id && (assignment?.clientMappingPreviousTherapist?.length > 0 ?
                                                                                    assignment?.clientMappingPreviousTherapist?.map((caseLoad) => {
                                                                                        return (
                                                                                            <tr style={{ backgroundColor: "white" }}>
                                                                                                <td style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: "0" }}>
                                                                                                    <div className="d-flex align-items-center gap-10">
                                                                                                        <img
                                                                                                            src={caseLoad?.caseTherapist?.therapist_detail?.profile_picture || userImg}
                                                                                                            width={26}
                                                                                                            height={26}
                                                                                                            style={{ borderRadius: "50%" }}
                                                                                                        />
                                                                                                        <span className="text-capitalize">{userFullName(caseLoad?.caseTherapist)}</span>
                                                                                                    </div>
                                                                                                </td>
                                                                                                <td colSpan={4} style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: "0" }}>
                                                                                                    <h6 style={{ fontWeight: "bold", textTransform: "capitalize" }}>{caseLoad?.status}ed on
                                                                                                        <span style={{ fontWeight: "normal", marginLeft: "10px" }}>{dateFormat(caseLoad?.createdAt, "MMM DD, YYYY hh:mm A")}</span>
                                                                                                    </h6>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    }) : <tr><td colSpan={2}><NoRecordFoundV2 className="mb-2" message="No Record Found" /></td></tr>)
                                                                                }
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                )
                                            }
                                        </>
                                        : <NoRecordFoundV2 message="No Record Found" />
                                }
                            </div>
                        </Container>
                    </section>
                </div>
            }
        </>
    );

};

export default CliniciansHistory;